import React from "react"
import DataTable from "react-data-table-component"
import OrderPlacedTick from "../../../../assets/images/cart/OrderPlacedTick.png"
import Tick from "../../../../assets/images/cart/Vector.png"


const Confirmation = () => {
  const data = [
    {
      orderId: "346345",
      noOfProducts: 1,
      provider: "Delivery: Mae-go",
      trackingId: "Mae-go3446477",
      invoiceId: "345345",
    },
  ]

  const columns = [
    { name: "Order ID", selector: (row) => row.orderId },
    { name: "No. of Products", selector: (row) => row.noOfProducts },
    { name: "Provider", selector: (row) => row.provider },
    { name: "Tracking ID", selector: (row) => row.trackingId },
    { name: "Invoice ID", selector: (row) => row.invoiceId },
  ]

  const customStyles = {
    table: {
      style: {
        border: "1px solid #D9D9D9",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#F2F2F2",
      },
    },
  }

  return (
    <div>
      <div className="text-center">
        <div style={{ position: "relative", display: "inline-block", height: '57px', width: '57px' }}>
          <img src={OrderPlacedTick} alt="" width="100%" />
          <span style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center" }}>
            <img src={Tick} alt="" width="50%" />
          </span>
        </div>
        <h5>Order is ready to be shipped</h5>
        <span style={{ fontWeight: 500, fontSize: "0.813rem" }}>Ship the order within next 24 hours</span>
      </div>

      <DataTable data={data} columns={columns} customStyles={customStyles} />
    </div>
  )
}

export default Confirmation
